import React from 'react';

const Preloader = function(props) {
    return (
      <div className = "preloader">
      	<div className = "blob-1"></div>
      	<div className = "blob-2"></div>
      </div>
    );
}
export default Preloader;
